import type { SchemaField } from '@cli-types/core-engine/schema.js'
import { toCamelCase } from '@cli-utils/text.js'
import { isUserRelationshipTarget } from '@core-engine/schema/system-relationships/is-user-relationship-target.js'
export function relationshipTableVar(field: SchemaField): string {
  return isUserRelationshipTarget(field.relationship) ? 'user' : toCamelCase(field.relationship!)
}
